<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/training-module" class="opacity-50 hover:opacity-100">Internship</router-link>
                        <span class="mx-2">/</span>
                        <span>Internship Program</span>
                    </div>
                    <div class="font-bold">Internship Program</div>
                </div>
                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between flex-wrap">
                        <h1 class="text-base md:text-lg font-semibold">Internship Program List</h1>
                    </div>
                    <div class="flex flex-col mt-4" v-if="$apollo.queries.internship_approvals.loading">
                        <table-shimmer
                            :titleHeaders="['#', 'Group Name', 'Internship Entity', 'Specialization', 'Start Date', 'End Date', 'Candidates Count', 'Actions']"
                            :rows="first"></table-shimmer>
                    </div>
                    <div v-else-if="!$apollo.queries.internship_approvals.loading && !hasItems"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No internship found!</h1>
                    </div>
                    <div v-else class="flex flex-col mt-4">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Ref No</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Group Name</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Internship Entity</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Specialization</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Start Date</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">End Date</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Candidates Count</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2"><span
                                                        class="font-medium cursor-pointer hover:underline hover:text-blue-600"
                                                        @click.stop="viewItem(item.internship)">{{
                                                            item.internship.ref_no }}</span></td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.internship.group_name }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.internship.partner.en_company_name }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.internship.field_of_training }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    getInterviewDate(item.internship.start_date) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    getInterviewDate(item.internship.end_date) }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div class="hover:underline hover:text-blue-600 cursor-pointer text-center"
                                                        @click.stop="showStudentsList(item.internship.id, item.internship.group_name)"
                                                        title="Click to view the students list">{{
                                                            item.internship.internship_candidates.length }}</div>
                                                </td>
                                                <td class="px-6 py-2">
                                                    <div class="flex">
                                                        <div v-if="hasPermission('internship-show')"
                                                            @click.stop="viewItem(item.internship)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-eye
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div>
                                                        <div @click.stop="approveBtnClicked(item.id, 1, item.internship)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-approve
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-approve>
                                                        </div>
                                                        <div @click.stop="rejectBtnClicked(item.id, 0)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-reject
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-reject>
                                                        </div>
                                                        <div @click.stop="rejectBtnClicked(item.id, 2)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-return
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-return>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="showAddNote" :title="addNoteTitle" @close="closeAddNote">
                            <div class="flex flex-col">
                                <label for="note" class="px-8 mt-4 text-sm ml-1">Add Your Note</label>
                                <div class="h-32 px-8 rounded-xl mt-2">
                                    <textarea v-model="note" placeholder="Type your comments here..."
                                        class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
                                </div>
                                <div class="flex justify-between mt-4 mx-8">
                                    <div @click.stop="closeAddNote"
                                        class="border-2 font-medium border-ternary text-ternary hover:text-white bg-white hover:bg-ternary rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                                        Cancel</div>
                                    <div @click.stop="addNoteOk"
                                        class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                                        Confirm</div>
                                </div>
                            </div>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="isViewItem" :title="getViewModalTitle" height="" @close="closeModal">
                            <internship-view class="text-left" :item="selectedItem" :view-type="viewType"
                                :college-student-programs="collegeStudentPrograms"
                                @confirm-application="confirmApplication"
                                @view-student-profile="viewStudentProfile"></internship-view>
                        </base-full-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="isShowCandidates"
                            :title="`Internship - ${selectedInternshipGroupName} - Students List`" height=""
                            @close="closeModal">
                            <internship-candidates :internship-id="selectedInternshipId" @close="closeModal"
                                @view-student-profile="viewStudentProfile"></internship-candidates>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="showFullModal" title="Student Profile" @close="closeFullModal">
                            <student-profile :student-id="studentId"></student-profile>
                        </base-full-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isLoading">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>

<script>
import IconEye from "../../components/icons/IconEye.vue";
import IconApprove from "../../components/icons/IconApprove.vue";
import IconReject from "../../components/icons/IconReject.vue";
import IconReturn from "../../components/icons/IconReturn.vue";
import gql from 'graphql-tag';
import Pagination from "../../components/shared/pagination.vue";
import TableShimmer from '../../components/shared/TableShimmer.vue';
import InternshipView from "./view.vue";
import { formattedDate } from "../../helpers/utils";
import InternshipCandidates from "./internship-candidates.vue";
import StudentProfile from "../student-profile/index.vue";
export default {
    name: "training-approval",
    components: {
        IconEye,
        IconApprove,
        IconReject,
        IconReturn,
        Pagination,
        TableShimmer,
        InternshipView,
        InternshipCandidates,
        StudentProfile,
    },
    data() {
        return {
            internship_approvals: [],
            first: 10,
            page: 1,
            isViewItem: false,
            selectedItem: null,
            isShowCandidates: false,
            selectedInternshipId: null,
            selectedInternshipGroupName: null,
            showFullModal: false,
            studentId: null,
            isLoading: false,
            note: "",
            showAddNote: false,
            selectedInternshipApprovalId: null,
            status: null,
            viewType: "normal",
            addNoteTitle: "",
            collegeStudentProgramsList: [],
        };
    },
    watch: {
        internship_approvals(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
    },
    computed: {
        items() {
            return this.internship_approvals.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.internship_approvals.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
        getViewModalTitle() {
            if (this.viewType == 'normal') {
                return `View Internship Group - ${this.selectedItem.group_name}(${this.selectedItem.ref_no})`;
            } else {
                return `Confirm Internship Group - ${this.selectedItem.ref_no}`;
            }
        },
        collegeStudentPrograms() {
            return this.collegeStudentProgramsList.data;
        },
    },
    apollo: {
        internship_approvals() {
            return {
                query: gql`query GetAllInternshipApprovals($first: Int!, $page: Int!) {
                    internship_approvals(first: $first, page: $page) {
                        error
                        error_code
                        message
                        data {
                            id
                            internship {
                                id
                                ref_no
                                token
                                group_name
                                field_of_training
                                start_date
                                end_date
                                supervisor
                                campus_code
                                level_code
                                program_code
                                training_document_url
                                sector
                                location
                                partner {
                                    id
                                    en_company_name
                                }
                                internship_candidates {
                                    student_id
                                    student {
                                        name_en
                                    }
                                }
                                internship_unselected_candidates {
                                    student_id
                                    student {
                                        name_en
                                    }
                                    reason
                                }
                                internship_approvals {
                                    user {
                                        name
                                    }
                                    role
                                    approved
                                    approved_at
                                    note
                                }
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
        collegeStudentProgramsList() {
            return {
                query: gql`query GetCollegeStudentProgramsList($is_enabled: Boolean) {
                    collegeStudentProgramsList(is_enabled: $is_enabled) {
                        data {
                            code
                            name
                        }
                    }
                }`,
                variables() {
                    return {
                        is_enabled: true,
                    }
                },
            }
        },
    },
    methods: {
        getInterviewDate(date) {
            return formattedDate(date);
        },
        setPage(page) {
            this.page = page;
        },
        closeModal() {
            this.viewType = "normal";
            this.isViewItem = false;
            this.selectedItem = null;
            this.isShowCandidates = false;
        },
        showToast(message = '') {
            this.$apollo.queries.internship_approvals.refetch();
            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'success',
                title: message
            })
            this.closeModal();
        },
        onUpdated() {
            this.showToast('Internship Group updated successfully');
        },
        hasPermission(crudName) {
            const permissions = this.$store.getters.permissions;
            const permissionsArray = permissions.split(",");
            if (permissionsArray.includes(crudName)) {
                return true;
            } else {
                return false;
            }
        },
        viewItem(item) {
            this.selectedItem = item;
            this.isViewItem = true;
        },
        showStudentsList(id, groupName) {
            this.selectedInternshipId = id;
            this.selectedInternshipGroupName = groupName;
            this.isShowCandidates = true;
        },
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showFullModal = true;
        },
        closeFullModal() {
            this.showFullModal = false;
            this.studentId = null;
        },
        closeAddNote() {
            this.showAddNote = false;
            this.note = "";
            this.selectedInternshipApprovalId = null;
        },
        rejectBtnClicked(id, status) {
            if (status == 0) {
                this.addNoteTitle = "Do you want to reject this application?";
            } else if (status == 2) {
                this.addNoteTitle = "Do you want to return this application?";
            } else {
                this.addNoteTitle = "";
            }
            this.selectedInternshipApprovalId = id;
            this.status = status;
            this.showAddNote = true;
        },
        addNoteOk() {
            this.showAddNote = false;
            this.updateApplication(this.selectedInternshipApprovalId, this.status);
        },
        approveBtnClicked(id, status, item) {
            if (this.role == 'internship_supervisor') {
                this.viewType = "confirmation";
                this.selectedInternshipApprovalId = id;
                this.status = status;
                this.viewItem(item);
            } else {
                this.updateApplication(id, status);
            }
        },
        confirmApplication(formData = null) {
            this.updateApplication(this.selectedInternshipApprovalId, this.status, formData);
        },
        async updateApplication(internship_approval_id, status, formData = null) {

            console.log(formData)

            this.isLoading = true;
            let error = null;
            let success = null;

            const UPDATE_INTERNSHIP_APPROVAL_MUTATION = gql`
                mutation UpdateInternshipApproval($internship_approval_id: Int!, $status: Int!, $note: String) {
                    updateInternshipApproval(internship_approval_id: $internship_approval_id, status: $status, note: $note) {
                        error
                        message
                    }
                }
            `;

            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_INTERNSHIP_APPROVAL_MUTATION,
                    variables: {
                        internship_approval_id: parseInt(internship_approval_id),
                        status: parseInt(status),
                        note: this.note,
                    }
                }).then((data) => {
                    if (data.data.updateInternshipApproval.error) {
                        error = data.data.updateInternshipApproval.message;
                    } else {
                        success = data.data.updateInternshipApproval.message;
                    }
                }).catch((error) => {
                    console.error(error)
                })
            } catch (err) {
                error = err.message || "Failed to authenticate, try later.";
            }

            if (error === null) {
                this.note = "";
                this.showToast(success);
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        this.note = "";
                    }
                })
            }

            this.isLoading = false;

        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>